import { BootstrapBrowserBuilder } from '@zg-rentals/rp-bootstrap-browser';
import { analytics } from './analytics';

const requestId = document.querySelector('meta[name=request_id]')?.getAttribute('content') ?? '';

export const bootstrap = new BootstrapBrowserBuilder('rent-payment-web', Number(__BUILD_NUMBER__))
  .withLoggerOptions({
    logPath: `/renter-hub/payments/log?requestId=${requestId}`,
  })
  .withDatadogPlugin('b5609748-c435-43fa-a20c-a3e8d75abbfd', 'pub93ef23763fade626c0fa4c0763d7e420')
  .withOnRegister(analytics.initialize)
  .build();
